import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/auth';

import Form from '../components/form/ui-semantic-form';
import FormElement from '../components/form/ui-semantic-form-elements';


export class LoginView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fields: {
				username: '', 
				password: ''
			},
			redirectTo: '/dashboard',
			isLoading: false
		};
	}
	onSuccess(data){
		//this.props.actions.loginUserSuccess(data.token);
		//this.props.afterLogin(data);
		//
		return data;
	}
	render () {
		let imgStyle = {
			width: '50%'
		};
		return (<div className="column">
				<h2 className="ui teal header">
					<img alt="" style={imgStyle} src={'static/img/glasstechnika-logo.png'} /><br />
					<h3 className="title">pro<span>HART</span></h3>
				</h2>
				<Form 
					url="auth/login" 
					class="large" 
					loading={this.state.isLoading} 
					action={this.props.actions.loginUser}
					onSuccess={this.onSuccess} 
					buttonSubmitTitle="Zaloguj">
						<div className="ui stacked segment">
							<FormElement 
								type="text" 
								name="email" 
								validations="isLength:1" 
								icon="user icon" 
								placeholder="Login" 
								required />
							<FormElement 
								type="password" 
								name="password" 
								validations="isLength:1" 
								icon="lock icon" 
								placeholder="Hasło" 
								required />
						</div>
				</Form>
				</div>
			);
	}
}

const mapStateToProps = (state) => ({
	isAuthenticating   : state.auth.isAuthenticating,
	statusText         : state.auth.statusText
});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);


/** WEBPACK FOOTER **
 ** ./js/views/LoginView.js
 **/